import css from 'styled-jsx/css'
import { colors, fontSizes, measurements } from 'theme'

export default css`
  .base-tooltip-container {
    position: relative;
  }

  .base-tooltip-container .tooltip-container {
    position: absolute;
    z-index: 100;
    display: none;
  }
  .base-tooltip-container .tooltip-container.is-open {
    display: initial;
    width: 20rem;
    min-height: 10rem;
    display: flex;
    padding: 0.5rem 0;
  }

  /* Tooltip positions */
  .base-tooltip-container .tooltip-container.tooltip-position-bottom {
    top: 100%;

    flex-direction: column;
  }
  .base-tooltip-container .tooltip-container.tooltip-position-top {
    bottom: 100%;

    flex-direction: column-reverse;
  }

  /* Tooltip aligns */
  .base-tooltip-container .tooltip-container.tooltip-align-left {
    right: 0;
  }
  .base-tooltip-container .tooltip-container.tooltip-align-right {
    left: 0;
  }

  /* Tooltip content*/
  .base-tooltip-container .tooltip-content {
    border-radius: ${measurements.borderRadius};
    padding: 1rem;

    overflow-y: hidden;
    max-height: 20rem;
  }

  .base-tooltip-container:hover .tooltip-content.overflow-scroll {
    overflow-y: scroll;
  }


  .base-tooltip-container .tooltip-content.bg-frame,
  .base-tooltip-container .tooltip-arrow.tooltip-arrow-bg-frame {
    background-color: ${colors.frame};
    color: ${colors.white};
    font-size: ${fontSizes.small};
  }

  .base-tooltip-container .tooltip-arrow {
    height: 1.5rem;
    width: 1.5rem;
    z-index: -1;
  }


  .tooltip-arrow-align-bottom-left,
  .tooltip-arrow-align-top-left {
    margin-left: auto;
    margin-right: 0.5rem;
  }

  .tooltip-arrow-align-bottom-left {
    transform: rotate(-45deg) translateX(-0.5rem);
    transform-origin: right bottom;
  }
  .tooltip-arrow-align-top-left {
    transform: rotate(45deg) translateX(-0.5rem);
    transform-origin: right top;
  }

  .tooltip-arrow-align-bottom-right,
  .tooltip-arrow-align-top-right {
    margin-right: auto;
    margin-left: 0.5rem;
  }

  .tooltip-arrow-align-bottom-right {
    transform: rotate(45deg) translateX(0.5rem);
    transform-origin: left bottom;
  }
  .tooltip-arrow-align-top-right {
    transform: rotate(-45deg) translateX(0.5rem);
    transform-origin: left top;
  }

  @media screen and (max-width: 992px) {
    .base-tooltip-container .tooltip-container.is-open {
      max-width: 15rem;
    }

    .base-tooltip-container .tooltip-content {
      max-height: 25rem;
    }
  }
`
